/*
 * webflow-embed
 * 
 * Sygnal Technology Group
 * https://www.sygnal.com
 * 
 * Embed content such as tables, and more. 
 */

import { Sa5Attribute } from '../globals';
import { VERSION } from '../version';
import { Sa5Core } from '../webflow-core';
import { Sa5Debug } from '../webflow-core/debug';
import { Sa5Embed } from '../webflow-embed';
// import { Sa5HtmlDynamicAttributes } from './webflow-html/dynamic-attributes'
// import { Sa5Breakpoints } from './webflow-html/breakpoints'

// interface Sa5EmbedConfig {

// //    dynamicAttributes?: boolean | true;
// //    handleBreakpointChange?: ((breakpointName: string, e: MediaQueryListEvent) => void) | null;
// //    handleOrientationChange?: ((orientationName: string, e: MediaQueryListEvent) => void) | null;

//     debug?: boolean | true;

// }


const initAsync = async() => { 

    //    new Sa5Core().init();
    let core: Sa5Core = Sa5Core.startup();
    
    // Initialize debugging
    let debug = new Sa5Debug("sa5-embed");
    debug.debug (`Initializing v${VERSION}`);

    // Init embeds
    
    const embedSelectors = [
//        'script[type="wfu-embed"]', // deprecated
        'script[type^="sygnal/embed"]' // e.g. sygnal/embed and sygnal/embed+hson
    ];

    document.querySelectorAll(embedSelectors.join(', '))
        .forEach(async (scriptElement: HTMLScriptElement) => {

        const webflowEmbed = await Sa5Embed.createFromScriptElementAsync(scriptElement); // ?.init();

    });

}


// Auto-execute on DOM load
if (document.readyState !== 'loading') {
    initAsync();
} else {
    document.addEventListener("DOMContentLoaded", initAsync);
}





